import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import { useAuth } from "../../context/AuthContext";
import DashboardMenu from "./DashboardMenu";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardMenuEach from "./DashboardMenuEach";
import Fade from "react-reveal/Fade";

const useStyles = makeStyles({
  body: { backgroundColor: "white", minHeight: "500px", padding: "50px" },
  title: { fontSize: "30px" },
});

const DashboardPassword = () => {
  const classes = useStyles();

  const [progress, setProgress] = useState(true);

  useEffect(() => {
    // console.log(stripUserId);
    setTimeout(() => {
      setProgress(false);
    }, 500);
  }, []);

  return (
    <Grid
      container
      sx={{
        px: { md: 10, sm: 5 },
        pt: 7,
        pb: 20,
        backgroundColor: "#eceff1",
      }}
    >
      <Grid item sm={12} md={12} sx={{ fontSize: "25px", pb: 2 }}>
        MY ACCOUNT
      </Grid>

      <Grid md={3} sm={12} sx={{}}>
        <DashboardMenuEach menu="Orders" link="/dashboard" cursor={true} />
        <DashboardMenuEach
          menu="Personal information"
          link="/dashboard-personal"
          cursor={false}
        />
        <DashboardMenuEach link="/" menu="Change password" cursor={false} />
        <DashboardMenuEach link="/" menu="Review" cursor={false} />
        <DashboardMenuEach link="/" menu="Request a support" cursor={false} />
      </Grid>
      <Grid md={9} sm={12} className={classes.body}>
        <Box className={classes.title}>
          <Fade delay={300}>Orders</Fade>
        </Box>
      </Grid>

      {/* <Grid s
				item
				sm={12}
				md={4}
				sx={{
					// border: "1px solid black",
					px: { md: 3 },
					py: { md: 5, sm: 4 },
				}}
			>
				<DashboardMenu page="profile" />
			</Grid>
			<Grid
				sm={12}
				md={8}
				item
				sx={{
					// border: "1px solid black",
					px: { md: 3 },
					py: { md: 5, sm: 2 },
				}}
			>
				<Box className={classes.body}>
					<Box
						sx={{
							width: "100%",
							py: 2,
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							overflow: "hidden",
						}}
					>
						<Box
							sx={{
								width: "100%",
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								boxSizing: "border-box",
								px: 4,
							}}
						>
							<Box sx={{ width: 1 }}>
								<Box
									sx={{
										pt: 1,
										fontSize: "23px",
										display: "flex",
										justifyContent: "space-between",
									}}
								>
									<Box>Dashboard</Box>
								</Box>
							</Box>

							<Box
								sx={{
									display: "flex",
									justifyContent: progress ? "center" : "flex-start",
									alignItems: "flex-start",
									width: "100%",
									minHeight: "400px",
									boxSizing: "border-box",
									pt: progress ? 5 : 0,
								}}
							>
								{progress ? (
									<CircularProgress />
								) : (
									<Box
										sx={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											pt: 2,
										}}
									></Box>
								)}
							</Box>
						</Box>
					</Box>
				</Box>
			</Grid> */}
    </Grid>
  );
};

export default DashboardPassword;
